document.addEventListener('DOMContentLoaded', function () {
    const currentLang = document.documentElement.lang;
    if (currentLang === 'en') {
        const button = document.querySelector('.area_pro_head .button');
        if (button) {
            button.remove();
        }
    }
});

document.addEventListener('click', function (e) {
    const loginButton = e.target.closest('.wishlist-hero-list-header-login');
    if (!loginButton) {
        return;
    }
    console.log("hellomd");
    if (window.location.pathname.startsWith('/en/')) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href =
            '/customer_authentication/login?return_to=%2Fen%2F';
    }
}, true);

// Hide Megamenu total and add text
// document.addEventListener('DOMContentLoaded', function () {
//     setTimeout(function () {
//         const currentLang = document.documentElement.lang;
//         if (currentLang === 'en') {
//             const elements = document.querySelectorAll(".lng-txtbx");
//             const hidelements = document.querySelectorAll(".cunt-tl");
//             elements.forEach(function (element) {
//                 element.textContent = "Products";
//             });
//             hidelements.forEach(function (element) {
//                 element.textContent = "";
//             });
//         }
//     }, 1000);
// });